import client from './client';

export default {

  /**
  * Authentication endpoints
  * */

  authenticateUser(payload) {
    return client().post('/auth/login', payload);
  },

  setEmployeeUnavailable(payload) {
    return client().put('/account/{id}', payload);
  },

  /**
  * Users shifts
  * */

  fetchShifts() {
    return client().get('/shifts');
  },

  updateShiftEmployeeStatus(payload) {
    return client().put(`/shift/${payload.shiftId}/employee/${payload.employeeId}`, { status: payload.status });
  },


  /**
   * Push tokens
   */
  saveUserPushToken(accountId, pushToken) {
    return client().post(`/account/${accountId}/push-token`, { token: pushToken });
  },

  /**
   * Users messages
   */
  fetchUsersMessages() {
    return client().get('/messages');
  },
};
